import Http from '@/services/httpVentures'

export const dashboardStats = () => Http.get('/admin/ventures/dashboard')
